import { pushCueUndo, clearCueHistory } from '../slices/cuePointsSlice';

// Snapshots cuesByFile before each undoable cue edit so Ctrl/Cmd+Z can restore it.
// Consecutive same-type edits within a short window are coalesced into ONE history
// entry — so a drag (many updateCue) or a multi-file generate is a single undo step.
const UNDOABLE = new Set([
    'cuePoints/addCue',
    'cuePoints/updateCue',
    'cuePoints/removeCue',
    'cuePoints/setCuesForFile',
    'cuePoints/setBatchResults',
]);
const COALESCE_MS = 500;

const cueHistoryMiddleware = (store) => (next) => (action) => {
    const type = action && action.type;

    // Reset coalescing so an edit right after undo/redo starts a fresh entry.
    if (type === 'cuePoints/undoCues' || type === 'cuePoints/redoCues') {
        cueHistoryMiddleware._lastType = null;
        return next(action);
    }
    // Clearing the file list wipes history too.
    if (type === 'cuePoints/resetCueFiles') {
        const result = next(action);
        store.dispatch(clearCueHistory());
        return result;
    }

    if (UNDOABLE.has(type)) {
        const now = Date.now();
        const coalesce = type === cueHistoryMiddleware._lastType
            && (now - (cueHistoryMiddleware._lastTime || 0)) < COALESCE_MS;
        cueHistoryMiddleware._lastType = type;
        cueHistoryMiddleware._lastTime = now;
        if (!coalesce) {
            const snapshot = store.getState().cuePoints.cuesByFile;
            store.dispatch(pushCueUndo(JSON.parse(JSON.stringify(snapshot || {}))));
        }
    }

    return next(action);
};

export default cueHistoryMiddleware;
